<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-3">
                <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                <input type="text" class="form-control" [(ngModel)]="filter.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                    (ngModelChange)="isFilterDirty = true;">
            </div>            
            <div class="form-group col-12 col-md-3">
                <label for="cnpjCpf" class="col-form-label">CNPJ/CPF</label>
                <input type="text" class="form-control" [(ngModel)]="filter.cnpjCpf" name="cnpjCpf" id="cnpjCpf"
                    (ngModelChange)="isFilterDirty = true;">
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Cadastro</label>
                <ss-multiselect-dropdown
                    [options]="multiselectCadastrosOptions"
                    [settings]="multiselectCadastrosSettings"
                    [texts]="multiselectCadastrosTexts"
                    [(ngModel)]="filter.cadastros"
                    (ngModelChange)="onChangeCadastros()">
                </ss-multiselect-dropdown>                
            </div>            
            <!-- <div class="form-group col-12 col-md-3">
                <label for="situacao" class="col-form-label">Situação</label>
                <select class="form-control" name="situacao" id="situacao" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true;">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>  
            </div>                                                                        -->
        </div>
        <div class="row">
            <div class="form-group col-12" [class.col-md-6]="!isRepresentante">
                <label for="cliente" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente [(ngModel)]="filter.cliente" name="cliente" id="cliente"
                    #cliente="ngModel" [ngControl]="cliente" (typeaheadChange)="onChangeCliente($event)">
                </sgt-typeahead-cliente>                                  
            </div>
            <div class="form-group col-12 col-md-6" *ngIf="!isRepresentante">
                <label for="representante" class="col-form-label">Representante</label>
                <sgt-typeahead-representante [(ngModel)]="filter.representante" name="representante" id="representante"
                    #representante="ngModel" [ngControl]="representante" (typeaheadChange)="onChangeRepresentante($event)">
                </sgt-typeahead-representante>                                                                  
            </div>             
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-6">
                 <label for="estado" class="col-form-label">Estado</label>
                 <select class="form-control" name="estado" id="estado"
                    [ngModel]="filter.idEstado || ''" (ngModelChange)="filter.idEstado = $event ? $event : null; isFilterDirty = true;">
                    <option value="">Todos os estados</option>
                    <option *ngFor="let estado of estados" [ngValue]="estado.id">{{estado.nome}}</option>
                </select>                 
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="cidade" class="col-form-label">Cidade</label>
                <sgt-typeahead-cidade [(ngModel)]="filter.cidade" name="cidade" id="cidade"
                    #cidade="ngModel" [ngControl]="cidade" (typeaheadChange)="onChangeCidade($event)">
                </sgt-typeahead-cidade>                    
            </div>
        </div>        
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Opções de E-commerce</label>
                <div class="container-ecommerce-opcoes">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="filter.ecommerce" (ngModelChange)="isFilterDirty = true" name="ecommerceFilter" id="ecommerceFilter">
                        <label class="custom-control-label" for="ecommerceFilter">E-commerce</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="filter.mercadoLivre" (ngModelChange)="isFilterDirty = true" name="mercadoLivreFilter" id="mercadoLivreFilter">
                        <label class="custom-control-label" for="mercadoLivreFilter">Mercado Livre</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="filter.marketplace" (ngModelChange)="isFilterDirty = true" name="marketplaceFilter" id="marketplaceFilter">
                        <label class="custom-control-label" for="marketplaceFilter">Marketplace</label>
                    </div>                                    
                </div>
            </div>            
        </div>  
        <div class="row">
            <div class="form-group col-12">
                <label for="nomeEcommerce" class="col-form-label">Nome Vendedor</label>
                <input type="text" class="form-control" [(ngModel)]="filter.nomeEcommerce" name="nomeEcommerce" id="nomeEcommerce" (ngModelChange)="isFilterDirty = true;">
            </div>             
        </div>      
    </div>
</div>